import { DataItem } from 'scrivito'

import { getInstanceIdFromUrl } from './getInstanceIdFromUrl'
import { isUTCDate } from './isUTCDate'

export const getPlanningBoardLink = (activity: DataItem): string => {
  const type = activity.get('type')
  if (type != 'APPOINTMENT') {
    return ''
  }
  const begin = activity.get('beginAt')
  const end = activity.get('endAt')

  if (isUTCDate(begin) && isUTCDate(end)) {
    return `https://edit-planningboard.justrelate.com/i/${getInstanceIdFromUrl()}?task_id=${activity.id()}&start_at=${begin}&end_at=${end}`
  }
  return ''
}
